// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__18lx_","shadow":"Page_shadow__xry8N"};